import styled from 'styled-components';

export const StyledBasicDatePicker = styled.div`
  border: 1px solid var(--color-pale-gray);
  border-radius: 0 !important;
`;
